/* OVSSC3 BRIDGE V1 — RETIRED 2026-06-26
 * This bridge has been retired. ovssc-bridge-dom-v1.js (dom-v11+) is now the sole bridge.
 * This file is kept as a no-op to avoid 404s on cached HTML that still references it.
 */
(function(){
  try {
    window.__ovssc3_bridge_retired = true;
    if (typeof console !== "undefined" && console.log) {
      console.log("[ovssc3-bridge] retired 2026-06-26 - sole bridge is ovssc-bridge-dom-v1");
    }
  } catch(e) {}
})();
